<div class="page-loader" [class.page-loader--loading]="show">
  <div class="page-loader__progress"></div>
</div>




